import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { ComponentSettingKey } from '@/shared/builder'
import { getSafely } from '@/shared/safely'

import { CompDataTableWrapperCore } from '../core/data-table/wrapper'
import { CompDataTable } from './CompDataTable'

/**
 * CompDataTableWrapper
 */
const CompDataTableWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const { listChecked, setListChecked } = useAppBuilderContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  // table data
  const { dbClient, tablesMap } = useDbClientContext()
  const tableId = getSafely(compContext.settings, [ComponentSettingKey.TableDataSource, 'table'], '')
  const dbTable = tableId ? tablesMap.get(tableId) : undefined

  // todo: error state
  if (!dbTable || !dbClient) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompDataTableWrapperCore
      infos={infosProps}
      action={actionContext}
      tableData={{ tableId, dbTable, dbClient }}
      listChecked={listChecked}
      setListChecked={setListChecked}
    >
      {(props) => <CompDataTable {...props} />}
    </CompDataTableWrapperCore>
  )
}

export default CompDataTableWrapper
